import { EntityEditFormModal } from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { getDocFlowBuildingScopePayload } from '../DocFlow.utils.scope'
import { DocFlowEditBuildingScopeFields } from '../DocFlowEditBuildingScopeFields'

import { DOC_FLOW_EDIT_BUILDING_SCOPE_MODAL_QA_NAME } from './DocFlowEditBuildingScopeModal.constants'

function DocFlowEditBuildingScopeModal({ initialValues, ...restProps }) {
  return (
    <EntityEditFormModal
      {...restProps}
      Fields={DocFlowEditBuildingScopeFields}
      formTitle='DocFlow.ModalEditBuildingScopeTitleKey'
      getPayload={getDocFlowBuildingScopePayload}
      initialValues={initialValues}
      qaName={DOC_FLOW_EDIT_BUILDING_SCOPE_MODAL_QA_NAME}
      validationSchema={formValidationSchemaNoChanged({ initialValues })}
    />
  )
}

export default DocFlowEditBuildingScopeModal
